import React from 'react';
import Link from 'next/link';
import styles from '../../styles/blog/featuredArticle.module.scss';

function formatDate(dateString) {
    if (!dateString) return '';
    const date = new Date(dateString);
    return date.toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' });
}

export default function FeaturedArticle({ article }) {
    if (!article) return null;

    return (
        <Link href={`/blog/${article.slug}`} className={styles.featured}>
            <div className={styles.imageWrapper}>
                <img
                    src={article.cover?.url || '/images/blog-placeholder.png'}
                    alt={article.cover?.alternativeText || article.title}
                    className={styles.image}
                />
                <div className={styles.imageOverlay}></div>
            </div>
            <div className={styles.content}>
                {article.category && (
                    <span className={styles.categoryBadge}>{article.category.name}</span>
                )}
                <h2 className={styles.title}>{article.title}</h2>
                {article.description && (
                    <p className={styles.excerpt}>{article.description}</p>
                )}
                <div className={styles.meta}>
                    {article.author && (
                        <span className={styles.author}>{article.author.name}</span>
                    )}
                    <span>{formatDate(article.publishedAt)}</span>
                    {article.readTime && (
                        <>
                            <span className={styles.dot}></span>
                            <span>{article.readTime} min read</span>
                        </>
                    )}
                </div>
                <span className={styles.readMore}>
                    Read Article
                    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M3.33337 8H12.6667" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                        <path d="M8 3.33337L12.6667 8.00004L8 12.6667" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                    </svg>
                </span>
            </div>
        </Link>
    );
}
